import { UserType } from 'data/types'

// Unified accounts have emailVerified, while legacy accounts have mercuryEmailVerified
// In the future we'll migrate all accounts to unfied and we can simplify this
export const isEmailVerified = (user: UserType): boolean =>
  user.unifiedAccountWalletGuid ? !!user.mercuryEmailVerified : !!user.emailVerified
